import { render, staticRenderFns } from "./PropriedadeList.vue?vue&type=template&id=2b9f00e8&scoped=true"
import script from "./PropriedadeList.vue?vue&type=script&lang=js"
export * from "./PropriedadeList.vue?vue&type=script&lang=js"
import style0 from "./PropriedadeList.vue?vue&type=style&index=0&id=2b9f00e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f00e8",
  null
  
)

export default component.exports